// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1TypesRejectTypesCodeRejectTypesResponse {
    static getAttributeTypeMap() {
        return ClaimV1TypesRejectTypesCodeRejectTypesResponse.attributeTypeMap;
    }
}
ClaimV1TypesRejectTypesCodeRejectTypesResponse.discriminator = undefined;
ClaimV1TypesRejectTypesCodeRejectTypesResponse.additionalProperties = false;
ClaimV1TypesRejectTypesCodeRejectTypesResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<ClaimParentLookupModel>"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=claimV1TypesRejectTypesCodeRejectTypesResponse.js.map